import { TrustCharter } from '@/components/employee/TrustCharter';
import { Card, CardContent } from '@/components/ui/card';

export default function Trust() {
  return (
    <div className="max-w-2xl mx-auto p-4 sm:p-8 space-y-6">
      <header>
        <h1 className="text-2xl sm:text-3xl font-heading font-semibold">Trust Center</h1>
        <p className="text-sm text-muted-foreground mt-1">
          The rules CultureLens runs on. Enforced in the database, not just in policy.
        </p>
      </header>
      <Card>
        <CardContent className="pt-6">
          <TrustCharter />
        </CardContent>
      </Card>
      <Card className="bg-muted/40">
        <CardContent className="pt-6 space-y-2">
          <h2 className="text-sm font-medium">How we enforce this technically</h2>
          <ul className="text-sm text-muted-foreground space-y-1 list-disc pl-5">
            <li>Aggregation queries hardcode a <code>k \u2265 5</code> floor and return nothing below it.</li>
            <li>A database-level trigger blocks anyone from ever adding raw-text columns to admin tables.</li>
            <li>All erasure actions are recorded in an immutable audit log.</li>
            <li>Each org has a unique hashing salt \u2014 no cross-org identity correlation is possible.</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
